import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { InvoicesService } from 'app/modules/admin/transactions/invoices/invoices.service';
import { Payment } from 'app/modules/admin/transactions/payments/payments.types';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: 'app-invoice-payment-list',
  templateUrl: './invoice-payment-list.component.html',
  // styleUrls: ['./invoice-payment-list.component.scss']
  styles: [
    /* language=SCSS */
    `
        .invoicepaymentlist-grid {
            grid-template-columns: 80px 120px 200px 200px auto 120px;
            @screen sm {
                grid-template-columns: 80px 120px 200px 200px auto 120px;
            }

            @screen md {
                 grid-template-columns: 80px 120px 200px 200px auto 120px;
            }

            @screen lg {
                grid-template-columns: 80px 120px 200px 200px auto 120px;
            }
        }
    `
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: fuseAnimations

})
export class InvoicePaymentListComponent implements OnInit {

  dialogTitle: string;
  payments$: Observable<Payment[]>;
  invoicepaymentlistTableColumns: string[] = ['id', 'date', 'bankName', 'bankBranchName', 'amount', 'tdsAmount'];
  selectedPayment: Payment;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data,
    private _matDialogRef: MatDialogRef<InvoicePaymentListComponent>,
    private _matDialog: MatDialog,
    private _invoicesService: InvoicesService,) {

      this.dialogTitle = `List of Payments for Invoice ${this._data.invNumber}`

  }

  ngOnInit(): void {
    this._invoicesService.getInvoicePaymentList(this._data.invoiceId).subscribe();

    this.payments$ = this._invoicesService.payments$;
  }

  onClose(): void {
    this._matDialogRef.close();
  }

}
